module.exports = __webpack_public_path__ + "img/hic-genitourinary-diseases-female.50567de8.png";